var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3077 19.6154H2.69231C1.75815 19.6154 1 18.8573 1 17.9231V14.5385C1 13.6043 1.75815 12.8462 2.69231 12.8462H21.3077C22.2418 12.8462 23 13.6043 23 14.5385V17.9231C23 18.8573 22.2418 19.6154 21.3077 19.6154Z",
    stroke: "#14192B",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1238 14.7683C18.7359 14.7683 18.3638 14.9224 18.0895 15.1967C17.8152 15.471 17.6611 15.843 17.6611 16.2309C17.6611 16.6189 17.8152 16.9909 18.0895 17.2652C18.3638 17.5395 18.7359 17.6936 19.1238 17.6936C19.5117 17.6936 19.8837 17.5395 20.158 17.2652C20.4323 16.9909 20.5864 16.6189 20.5864 16.2309C20.5864 15.843 20.4323 15.471 20.158 15.1967C19.8837 14.9224 19.5117 14.7683 19.1238 14.7683Z",
    fill: "#14192B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.3846V14.1154L20.7272 2.37077C20.5732 1.57538 19.876 1 19.0654 1H4.93462C4.124 1 3.42677 1.57538 3.27277 2.37077L1 14.1154V15.3846",
    stroke: "#14192B",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.c0d77ba82c6a40619704253e35e62c1e.svg";
export { ForwardRef as ReactComponent };